import DnDTable from "./DnDTable";
import withQueryParamsHandler from "./withQueryParamsHandler";

export default withQueryParamsHandler(DnDTable);
